import { ExpandMore } from '@mui/icons-material';
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, styled, Typography } from '@mui/material';

export const Accordion = styled(MuiAccordion, {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  padding: '0 !important',
  border: `1px solid ${error ? theme.palette.error.main : theme.palette.divider}`,
  '&:before': { display: 'none' },
}));

export const AccordionSummary = styled(MuiAccordionSummary, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded: boolean }>(({ expanded }) => ({
  minHeight: 'auto',
  '& .MuiAccordionSummary-content': { display: 'flex', alignItems: 'center', margin: 0, paddingTop: expanded ? '10px' : 0 },
}));

export const ExpandIcon = styled(ExpandMore, { shouldForwardProp: (prop) => prop !== 'expanded' })<{ expanded: boolean }>(({ expanded }) => ({
  transition: '0.2s',
  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
  marginRight: '8px',
}));

export const Title = styled(Typography)({
  flexGrow: 1,
});
